<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
		<template #hero>
			<div class="search-swiper-container">
				<Swiper :list="banners" :show-header="false"/>
				<search-bar-pic :is-need-redirect="isNeedRedirect"></search-bar-pic>
			</div>
		</template>
		<div class="container" ref="viewBox">
			<div class="pic-content">
				<div class="enclosure" style="">
					<section class="section">
						<Loading :is-loading="isPicLoading"></Loading>
						<div class="_1Aw4E" v-for="item in subjectCats">
							<a class="img">
								<img :src="item.thumb" @click.stop="toSubjectCategory(item.id)" oncontextmenu="return false"/>
								<span class="category-name" @click.stop="toSubjectCategory(item.id)">{{item.title}}</span>
							</a>
						</div>
					</section>
				</div>
			</div>
			<Footer/>
		</div>
	</NewIndexSiteLayout>
</template>

<script>
	import topic_pic from './topic_pic_controller';
	export default topic_pic;
</script>

<style src="@/assets/css/topic_pic.css" scoped></style>
